var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"panel_close-btn d-flex py-7 px-10",on:{"click":_vm.close}},[_c('v-img',{staticClass:"mr-4",attrs:{"src":"/images/arrow_left.svg","max-width":"12","height":"18"}}),_c('span',{staticClass:"f14 green2"},[_vm._t("default",function(){return [_vm._v(" "+_vm._s(_vm.text)+" ")]})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }